export default{
    // UI
    alt_filters_filter: "LED-alternativ Filter",
    ballast_notice: "Ballastkompatibiliteten for elektronisk ballast (HF) skal kontrolleres.",
    ballast_notice_tled_link_text: "LED-lysrør",
    ballast_notice_pl_led_link_text: "LED PL-lyskilder",

    // LED facets
    tiering: "Produktserie",
    ballast_compatibility: "Forkoblingskompatibilitet",
    lifetime: "Levetid",
    lumen: "Lumen",
    led_no_recommendations: "Der er ingen LED-alternativer til dette produkt.",
    
    home_search_for_product: "Søg efter dit produkt",
    conventional_alternative: "Konventionelt alternativ",
    led_alternative: "LED alternativ",
    search_filters_filter: "Filtrer",
    search_submit: "Søg efter produkt",
    results: "Resultat",
    selected_product: "Udvalgte produkter",
    search_input: "Indtast (en del af) produktkoden eller beskrivelsen",
    what_type_are_you_looking_for: "Hvilken type produkterstatning leder du efter?",
    recommendations_singular: "Anbefalinger",
    recommendations_plural: "Anbefalinger",
    your_product: "Dit produkt",
    search_filters_reset: "Nulstil filtre",
    results_specify: "Der er mere end 10 resultater, indtast flere specifikationer",
    energy_efficient: "Energie ffektivitet",
    active_filters: "Aktive filtre",
    card_action: "Katalog",
    card_show_more: "Vis mere",
    card_show_less: "Vis mindre",
    card_alternative_fit: "Bedste Philips alternativ",
    card_perfect_fit: "Bedste Philips match",
    no_results_found: "Ingen resultater fundet. Søg venligst igen",
    results_no_recommendations: "Er du i tvivl? Kontakt venligst din lokale account manager eller salgsrepræsentant for at finde en løsning.",
    search_filter_product_type: "Produkttype",
    lighting_type: "Lyskildetype",
    ean: "EAN",
    product_code: "Produktkode",
    eoc: "EOC",
    family: "Produktfamilie",
    discrete_wattage: "Watt",
    wattage: "Watt",
    brand: "Mærke",
    driver_type: "Driver type",
    number_of_lamps: "Antal lyskilder",
    length: "Længde",
    color: "Farvekode",
    base: "Type",
    local_eoc: "Lokal kode",
    ignitor: "Tændingsenhed",
    height: "Højde",
    width: "Bredde",
    mounting_hole: "Monteringshul",
    mains_voltage: "Netspænding",
    thermal_protection: "Termisk beskyttelse",
    delta_temperature: "Delta temperatur",
    energy_efficiency: "Energieffektivitet",
    losses: "Tab",
    lamp_current: "Armaturstrøm",
    pf_cap: "PF kapsel",
    energy_saving: "Energibesparelse",
};
